import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder, Row, Col } from '@thd-olt-component-react/core-ui';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel,
  extend,
} from '@thd-nucleus/data-sources';
import { SALSIFY } from '../../constants';
import { RevJet } from '../RevJet/RevJet';
import { Salsify } from '../Salsify/Salsify';

export const KeyFeaturesComponent = ({ itemId, revJet }) => {
  const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (loading) {
    return (
      <Placeholder
        type="rect"
        height="133px"
        width="100%"
      />
    );
  }

  if (!data || error || !itemId) {
    return null;
  }

  const {
    richContent
  } = data?.product?.media || {};

  const etchContent = richContent?.content;
  const richContentSource = richContent?.richContentSource;
  const salsify = richContentSource === SALSIFY;
  const salsifyRichContent = richContent?.salsifyRichContent;
  if (!richContent && !revJet && !salsify) {
    return null;
  }
  if (revJet) {
    return (
      <Row title="Key Features" className="key-features-content">
        <RevJet itemId={itemId} parentId="revJet-key-features-summary" />
      </Row>
    );
  }

  return (
    <Row title="Key Features" className="key-features-content">
      {salsify ? (
        <Col>
          <Salsify salsifyRichContent={salsifyRichContent} parentId="salsify-key-features-summary" />
        </Col>
      ) : (
        <EtchWidgets content={etchContent} />
      )}
    </Row>
  );

};

KeyFeaturesComponent.displayName = 'KeyFeaturesComponent';

const dataModel = extend({
  product: params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    itemId: stringType(),
    media: shapeType({
      richContent: shapeType({
        content: stringType(),
        richContentSource: stringType(),
        salsifyRichContent: stringType()
      })
    })
  })
}, EtchWidgets);

const propTypes = {
  itemId: PropTypes.string.isRequired,
  revJet: PropTypes.bool,
};

const defaultProps = {
  revJet: false,
};
KeyFeaturesComponent.dataModel = dataModel;
KeyFeaturesComponent.propTypes = propTypes;
KeyFeaturesComponent.defaultProps = defaultProps;

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-key-feat',
  placeholder: (
    <Placeholder
      type="rect"
      height="133px"
      width="100%"
    />
  ),
  scrollBuffer: 750,
}, KeyFeaturesComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
const KeyFeatures = withLayoutGroup({
  name: 'key-features'
}, DynamicComponent);

KeyFeatures.dataModel = dataModel;
KeyFeatures.propTypes = propTypes;
KeyFeatures.defaultProps = defaultProps;
KeyFeatures.displayName = 'KeyFeatures';
export { KeyFeatures };
